import externalRoutes from './externalRoutes';

/**
 * The root domain.
 */
const rootDomain = (): string => {
  // Find the current hostname
  const { hostname } = window.location;

  // Remove "dashboard." from the hostname
  return hostname.replace('dashboard.', '');
};

/**
 * The base API URL.
 */
export const apiUrl = (): string =>
  `${window.location.protocol}//api.${rootDomain()}`;

/**
 * The base admin dashboard URL.
 */
export const adminDashboardUrl = (): string =>
  `${window.location.protocol}//admin.${rootDomain()}`;

/**
 * Ensure path starts with a "/".
 *
 * @param path
 */
export const normalisePath = (path: string): string => {
  if (path.charAt(0) !== '/') {
    return `/${path}`;
  }

  return path;
};

/**
 * The application's base URL, including protocol.
 */
export const baseUrl = (): string =>
  `${window.location.protocol}//${window.location.host}`;

/**
 * Is the current route an external route.
 */
export const isExternalRoute = (): boolean => {
  // If the current route matches a defined route
  if (useRoute().matched[0]) {
    // Determine if the current route is included in the defined external routes
    return externalRoutes.includes(useRoute().matched[0].path);
  }

  // The route is not external
  return false;
};

/**
 * Construct a help site link using the help base URL from the NUXT_PUBLIC_HELP_BASE environment
 * variable.
 *
 * @param path
 */
export const helpUrl = (path: string): string =>
  useCommonStore().partner.help_centre_url + normalisePath(path);

/**
 * The path to use as the homepage when redirecting from login, create/edit forms, and "Back to
 * dashboard" links.
 */
export const homePath = (): string => {
  const { role, user } = useAuthStore();

  if (role === 'super_admin' || role === 'admin') {
    return '/products';
  }

  if (role === 'supervisor' || role === 'reservations') {
    return '/orders';
  }

  // Front desk roles need view_orders to be at home in the dashboard; the
  // legacy three-permission sets stay on the terminal.
  if (
    (role === 'front_desk' || role === 'front_desk_link_pay') &&
    (user?.permissions?.includes('view_orders') ?? false)
  ) {
    return '/orders';
  }

  if (role === 'redeem') {
    return '/terminal/redeem';
  }

  // legacy front desk sets, sell_and_redeem,
  // sell_and_redeem_without_discounts, or no role
  return '/terminal';
};
